import React, { useEffect, useRef } from "react";

const Pipcalc = () => {
const lotsizecalc = useRef(null);

  useEffect(() => {
    const RemoteCalc = (WidgetConfig) => {
      return WidgetConfig;
    };

    const script = document.createElement("script");
    script.src = "https://www.cashbackforex.com/Content/remote/remote-widgets.js";
    script.async = false;

    script.innerHTML = JSON.stringify(
      RemoteCalc({
        Url: "https://www.cashbackforex.com",
        TopPaneStyle: "YmFja2dyb3VuZDogd2hpdGU7IGNvbG9yOiBibGFjazsgYm9yZGVyOiBzb2xpZCAxcHggYmxhY2s7IGJvcmRlci1ib3R0b206IG5vbmU7IA==",
        BottomPaneStyle: "YmFja2dyb3VuZDogd2hpdGU7IGJvcmRlcjogc29saWQgMXB4IGJsYWNrOyBjb2xvcjogYmxhY2s7",
        ButtonStyle: "YmFja2dyb3VuZDogb3JhbmdlOyBjb2xvcjogd2hpdGU7IGJvcmRlci1yYWRpdXM6IDIwcHg7",
        TitleStyle: "dGV4dC1hbGlnbjogbGVmdDsgZm9udC1zaXplOiA0MHB4OyBmb250LXdlaWdodDogNTAwOw==",
        TextboxStyle: "YmFja2dyb3VuZC1jb2xvcjogd2hpdGU7IGNvbG9yOiBibGFjazsgYm9yZGVyOiBzb2xpZCAxcHggI2FhYWFhYQ==",
        ContainerWidth: "900",
        DefaultInstrument: "EUR-USD",
        HighlightColor: "#ffff00",
        IsDisplayTitle: true,
        IsShowChartLinks: false,
        IsShowEmbedButton: false,
        CompactType: "large",
        Calculator: "position-size-calculator",
        ContainerId: "position-size-calculator-345059",
      })
    );

    lotsizecalc.current.appendChild(script);
  }, []);

    return (
        <div>
            <div className="pipcalculator">

                <div
                    id="position-size-calculator-345059"
                    ref={lotsizecalc}
                ></div>

            </div>
        </div>
    );
};

export default Pipcalc;
